import { elements, modifiers } from '#components/generics/js/styles.js'
import { elements as calendarElements } from '../../../../styles.js'
import * as utilities from '#utilities/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as menu from '#utilities/js/lightboxes/menus/menu.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const { ownerdocument } = button
    const wrapper = one(`.${calendarElements.eventRepeat}`, ownerdocument)
    const hiddens = all(`.${modifiers.new_field_input.new_hidden}`, wrapper)
    const buttonAdd = one(`.${calendarElements.eventRepeatAdd}`, wrapper)
    const blockText = one(`.${calendarElements.eventRepeatTile}`, wrapper)

    for (const hidden of hiddens) {
      hidden.remove()
    }

    menu.close()
    blockText.remove()
    buttonAdd.classList.remove(utilities.modifiers.display.none)
  }
})

export default button => {
  onClick.listen(button)
}
